import React from 'react';

interface MHeaderProps {
  children: React.ReactNode;
}

const MHeader: React.FC<MHeaderProps> = ({children}) => {
  return (
    <React.Fragment>
      <div className='mjp-modal-header'>
        {children}
      </div>
    </React.Fragment>
  )
}

export default MHeader;